import { useEffect, useState } from 'react';

export default function Loader({ onComplete }) {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    const tick = setInterval(() => {
      setPct((p) => {
        let increment;

        if (p < 50) increment = 5;
        else if (p < 90) increment = 4;
        else increment = 1;

        const next = Math.min(100, p + increment);

        if (next >= 100) {
          clearInterval(tick);
          onComplete?.();
        }

        return next;
      });
    }, 100);

    return () => clearInterval(tick);
  }, [onComplete]);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Source+Serif+4:wght@400;600;700&display=swap');
        .loader-root {
          position: fixed; inset: 0; z-index: 9999;
          background: #F7F9FC;
          display: flex; flex-direction: column; align-items: center; justify-content: center;
          font-family: 'Inter', sans-serif;
        }
        .loader-brand {
          font-family: 'Source Serif 4', serif;
          font-size: 13px; letter-spacing: 0.35em; text-transform: uppercase;
          color: #0F766E; margin-bottom: 2.5rem;
          animation: lFadeUp 0.6s 0.2s both;
        }
        .virus-wrap { position: relative; width: 140px; height: 140px; }
        .virus-wrap svg { width: 100%; height: 100%; animation: lSpin 6s linear infinite; transform-origin: center; }
        .pulse-ring {
          position: absolute; border-radius: 50%; border: 1px solid rgba(15,118,110,0.16);
          animation: lPulse 2.4s ease-in-out infinite;
          pointer-events: none;
        }
        .pulse-ring:nth-child(1) { inset: -20px; }
        .pulse-ring:nth-child(2) { inset: -36px; animation-delay: 0.8s; border-color: rgba(15,118,110,0.10); }
        .loader-bar-wrap { width: 180px; height: 1px; background: #E2E8F0; margin-top: 2.8rem; border-radius: 2px; overflow: hidden; }
        .loader-bar-fill { height: 100%; background: linear-gradient(90deg, #0F766E, #14B8A6); transition: width 0.08s linear; }
        .loader-pct { font-size: 12px; color: #0F766E; letter-spacing: 0.15em; margin-top: 0.8rem; font-weight: 500; }
        @keyframes lSpin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes lPulse { 0%,100% { transform: scale(1); opacity: 0.5; } 50% { transform: scale(1.18); opacity: 1; } }
        @keyframes lFadeUp { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: none; } }
      `}</style>

      <div className="loader-root">
        <div className="loader-brand">ViralOmics</div>
        <div className="virus-wrap">
          <div className="pulse-ring" />
          <div className="pulse-ring" />
          <svg viewBox="0 0 120 120" fill="none">
            <circle cx="60" cy="60" r="32" stroke="#0F766E" strokeWidth="1.5"/>
            <line x1="60" y1="40" x2="60" y2="30" stroke="#0F766E" strokeWidth="1"/>
            <line x1="60" y1="80" x2="60" y2="90" stroke="#0F766E" strokeWidth="1"/>
            <line x1="40" y1="60" x2="30" y2="60" stroke="#0F766E" strokeWidth="1"/>
            <line x1="80" y1="60" x2="90" y2="60" stroke="#0F766E" strokeWidth="1"/>
            <line x1="46" y1="46" x2="38" y2="38" stroke="#0F766E" strokeWidth="1"/>
            <line x1="74" y1="74" x2="82" y2="82" stroke="#0F766E" strokeWidth="1"/>
            <line x1="74" y1="46" x2="82" y2="38" stroke="#0F766E" strokeWidth="1"/>
            <line x1="46" y1="74" x2="38" y2="82" stroke="#0F766E" strokeWidth="1"/>
            <line x1="60" y1="28" x2="60" y2="16" stroke="#14B8A6" strokeWidth="1.2"/>
            <circle cx="60" cy="13" r="4" stroke="#0F766E" strokeWidth="1.2"/>
            <line x1="60" y1="92" x2="60" y2="104" stroke="#14B8A6" strokeWidth="1.2"/>
            <circle cx="60" cy="107" r="4" stroke="#0F766E" strokeWidth="1.2"/>
            <line x1="28" y1="60" x2="16" y2="60" stroke="#14B8A6" strokeWidth="1.2"/>
            <circle cx="13" cy="60" r="4" stroke="#0F766E" strokeWidth="1.2"/>
            <line x1="92" y1="60" x2="104" y2="60" stroke="#14B8A6" strokeWidth="1.2"/>
            <circle cx="107" cy="60" r="4" stroke="#0F766E" strokeWidth="1.2"/>
            <line x1="37" y1="37" x2="27" y2="27" stroke="#14B8A6" strokeWidth="1.2"/>
            <circle cx="24" cy="24" r="4" stroke="#0F766E" strokeWidth="1.2"/>
            <line x1="83" y1="37" x2="93" y2="27" stroke="#14B8A6" strokeWidth="1.2"/>
            <circle cx="96" cy="24" r="4" stroke="#0F766E" strokeWidth="1.2"/>
            <line x1="37" y1="83" x2="27" y2="93" stroke="#14B8A6" strokeWidth="1.2"/>
            <circle cx="24" cy="96" r="4" stroke="#0F766E" strokeWidth="1.2"/>
            <line x1="83" y1="83" x2="93" y2="93" stroke="#14B8A6" strokeWidth="1.2"/>
            <circle cx="96" cy="96" r="4" stroke="#0F766E" strokeWidth="1.2"/>
          </svg>
        </div>
        <div className="loader-bar-wrap">
          <div className="loader-bar-fill" style={{ width: `${pct}%` }} />
        </div>
        <div className="loader-pct">{pct}%</div>
      </div>
    </>
  );
}